import React, { Component } from 'react';
import { withRouter } from 'react-router'
import { connect } from 'react-redux';
import { Page404 } from '../Page404';
import { EventsActions } from '../../actions';
import './eventPageBlankTemplate.scss';

class EventPageTemplateBlank extends Component {
    constructor(props) {
        super(props);

        this.state = {
            eventID: null,
            data: {}
        }
    }

    componentDidMount() {
        const {dispatch} = this.props;
        const eventID = this.state.eventID;
        
        dispatch(EventsActions.getEventData(eventID));
        dispatch(EventsActions.setCurrentEventID(eventID));
    }

    componentWillUnmount() {
        const {dispatch} = this.props;
        dispatch(EventsActions.unSetCurrentEventID());
    }

    static getDerivedStateFromProps(props, state) {
        const eventID = props.match.params.eventID;

        if(state.eventID !== eventID) {
            return {eventID: eventID}
        }
            
        return null;
    }

    render() {  
        const {events, children} = this.props;
        if(events.getEventError === true) return (<Page404/>);

        return (
            <div id="eventPageBlankTemplate">
                {children}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        events: state.eventsReducer
    }
}

const EventPageTemplateBlankWithRedux = withRouter(connect(mapStateToProps)(EventPageTemplateBlank));

export {EventPageTemplateBlankWithRedux as EventPageTemplateBlank};


// WEBPACK FOOTER //
// ./src/components/EventPage/EventPageBlankTemplate.jsx